import { Size } from './CountryPicker.type';
// Defines the size of icons based on predefined size categories to maintain design consistency.
export const IconSizes: Record<Size, number> = {
  xs: 8,
  sm: 10,
  md: 12,
  lg: 14,
  xl: 16,
};
// Maps predefined size categories to specific numerical values to standardize label sizes throughout the component.
export const LabelSizes: Record<Size, number> = {
  xs: 8,
  sm: 10,
  md: 12,
  lg: 14,
  xl: 16,
};
